/* ============================================================
   MONNAIE DU MONDE — product.js
   Fiche produit : ajout au panier (bloc « Produit — Prix et bouton d'achat »).
   - respecte la limite d'achat (par commande ou « 1 par personne » : panier + commandes précédentes) ;
   - message et animation de confirmation (la pièce tombe dans le panier) ;
   - l'état du bouton (disponible / prévente / à venir / indisponible / épuisé) est piloté par disponibilite.js.
   La galerie (flèches, vignettes, zoom, plein écran) est dans produit-galerie.js.
   Idempotent, compatible éditeur de thème.
   ============================================================ */
(function () {
  'use strict';
  if (window.mdmInitProduit) { window.mdmInitProduit(document); return; }

  function initFormulaire(form) {
    if (form.__mdmAchat) return;
    form.__mdmAchat = true;
    var bouton = form.querySelector('[data-bouton-achat]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!bouton || bouton.disabled || bouton.getAttribute('aria-busy') === 'true') return;
      var etat = bouton.getAttribute('data-etat');
      if (etat !== 'disponible' && etat !== 'prevente') return;
      bouton.setAttribute('aria-busy', 'true');
      var opts = window.mdmOptionsAjout ? window.mdmOptionsAjout(bouton) : {};
      opts.bouton = bouton;
      window.mdmAjouter(bouton.getAttribute('data-variante'), +bouton.getAttribute('data-limite') || 10, bouton.getAttribute('data-titre') || '', opts)
        .then(function () { bouton.removeAttribute('aria-busy'); });
    });
  }

  window.mdmInitProduit = function (racine) {
    (racine || document).querySelectorAll('form.produit-achat__form').forEach(initFormulaire);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.mdmInitProduit(document); });
  else window.mdmInitProduit(document);
  document.addEventListener('shopify:section:load', function (e) { window.mdmInitProduit(e.target); });
})();
